import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

import { selectors } from '../redux'
import { router, routesPath } from '../router'

interface DeclarationGuardType {
  children: React.ReactNode
}

// For routes that can only be accessed by authenticated users
function DeclarationGuard({ children }: DeclarationGuardType) {
  const user = useSelector(selectors.auth.user)

  if (!user?.declaration.id && user?.cgu_accepted_at) {
    return <Navigate to={router(routesPath.declaration)} />
  }

  return children
}

export default DeclarationGuard
